import { formatMagnification } from 'components/Procedure/SlideMagnification';
import { Slide } from 'interfaces/slide';
import { compact, join } from 'lodash';
import { formatSlideResolution } from 'utils/helpers';

export interface SlideMetadataChipItem {
  key: string;
  label: string;
  textForCopy?: string;
}

export const getSlideMetadataValues = (slide: Slide): string[] => {
  const scannerLabel = join(compact([slide.scannerManufacturer, slide.scannerModel]), ' ');

  return compact([
    slide.maxResolution ? formatSlideResolution(slide.maxResolution) : null,
    slide.objectiveMagnification ? `${formatMagnification(slide.objectiveMagnification)}x` : null,
    scannerLabel || null,
  ]);
};

export const getSlideMetadataChipItems = (slide: Slide): SlideMetadataChipItem[] => {
  const scannerLabel = join(compact([slide.scannerManufacturer, slide.scannerModel]), ' ');

  return compact([
    slide.id
      ? {
          key: 'slide-id',
          label: slide.id.slice(0, 8),
          textForCopy: slide.id,
        }
      : null,
    slide.maxResolution
      ? {
          key: 'resolution',
          label: formatSlideResolution(slide.maxResolution),
        }
      : null,
    scannerLabel
      ? {
          key: 'scanner',
          label: scannerLabel,
        }
      : null,
    slide.objectiveMagnification
      ? {
          key: 'objective-magnification',
          label: `${formatMagnification(slide.objectiveMagnification)}x`,
        }
      : null,
  ]);
};
